import Enums from 'utils/EnumsManager';
import { SET_MODULES, SET_MODULE_DATA, SET_MODULE_READONLYMODE, RESET_MODULE_READONLYMODE, RESET_MODULES } from './actionTypes';

const { Invoice, Attachments, TaskOpen } = Enums.DetailModules;

const initialState = {
  modules: [],
  moduleReadonlyMode: {
    [`${TaskOpen}ReadonlyMode`]: true,
    [`${Attachments}ReadonlyMode`]: true,
    [`${Invoice}ReadonlyMode`]: true,
  },
};

const subpanels = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODULE_DATA:
      const { code, data, meta } = action.payload;
      return {
        ...state,
        [code]: {
          data,
          meta,
        },
      };

    case SET_MODULES:
      const { modules } = action.payload;
      return {
        ...state,
        modules: _.sortBy(modules, ['sequence']),
      };

    case RESET_MODULES:
      return {
        ...state,
        modules: initialState.modules
      };

    case SET_MODULE_READONLYMODE:
      const { moduleName } = action.payload;
      return {
        ...state,
        moduleReadonlyMode: {
          ...state.moduleReadonlyMode,
          [`${moduleName}ReadonlyMode`]: false,
        },
      };

    case RESET_MODULE_READONLYMODE:
      const { moduleType } = action.payload;
      return {
        ...state,
        moduleReadonlyMode: {
          ...state.moduleReadonlyMode,
          [`${moduleType}ReadonlyMode`]: initialState.moduleReadonlyMode[`${moduleType}ReadonlyMode`],
        },
      };
  

    default:
      return state;
  }
};

export default subpanels;



// WEBPACK FOOTER //
// ./src/components/page/DetailsSubpanels/flow/reducer.js